import { render } from "./McCheckbox.vue?vue&type=template&id=3d020b04"
import script from "./McCheckbox.vue?vue&type=script&lang=js"
export * from "./McCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__